module.exports = __webpack_public_path__ + "img/2d3bd1b.jpg";